import {
	AppSocketType,
	SocketCommands,
	SocketNS,
	socketSelector,
	socketSlice,
	WorkerEvent,
} from 'Modules/Socket'
import { put, select } from 'typed-redux-saga'

export function* unSubscribeChannels(action: SocketNS.UnSubscribeChannels) {
	if (!(yield* select(socketSelector.selectHasWorker))) return

	const channels = [...(yield* select(socketSelector.selectChannels))]
	const deleteChannelsSet = new Set(action.payload)
	const filteredChannels = channels.filter((item) => !deleteChannelsSet.has(item))
	yield* put(socketSlice.actions.setChannels(new Set(filteredChannels)))

	action.payload.forEach((channel) =>
		navigator.serviceWorker.controller.postMessage({
			appSocketType: AppSocketType.NEO,
			data: {
				type: WorkerEvent.SEND_MESSAGE,
				payload: JSON.stringify({
					command: SocketCommands.UNSUBSCRIBE,
					identifier: `{"channel":"${channel}"}`,
				}),
			},
		})
	)
}
